import React, { Component } from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../../../infrastructure/translate/localization";
import "./drop-down.scss";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    const { title } = this.props;
    this.state = {
      listOpen: false,
      headerTitle: title,
      selection: [],
    };
  }

  clearSelection = () => {
    const { title, changeSelected } = this.props;
    this.setState({
      selection: [],
      headerTitle: title,
      listOpen: false,
    });
    changeSelected([]);
  };

  handleSelect(item) {
    const { selection } = this.state;
    const { multiSelect, items, changeSelected, title } = this.props;
    if (!selection.some((current) => current === item.id)) {
      if (!multiSelect) {
        this.setState({
          selection: [item.id],
          headerTitle: item.name,
          listOpen: false,
        });
        changeSelected([item.id]);
      } else if (multiSelect) {
        const selectedItems = [...selection, item.id];
        if (selectedItems.length === 1) {
          this.setState({ headerTitle: item.name });
        } else if (selectedItems.length === items.length) {
          this.setState({ headerTitle: translate("common-messages.all") });
        } else if (selectedItems.length > 1) {
          this.setState({
            headerTitle: `${item.name} +${selectedItems.length - 1}`,
          });
        }

        this.setState({ selection: selectedItems });
        changeSelected(selectedItems);
      }
    } else {
      let selectionAfterRemoval = selection;
      selectionAfterRemoval = selectionAfterRemoval.filter(
        (current) => current !== item.id
      );

      if (selectionAfterRemoval.length === 0) {
        this.setState({ headerTitle: title });
      } else if (selectionAfterRemoval.length === 1) {
        const onlyOne = items.find((i) => i.id === selectionAfterRemoval[0]);
        this.setState({ headerTitle: onlyOne.name });
      } else if (selectionAfterRemoval.length > 1) {
        const lastItemId =
          selectionAfterRemoval[selectionAfterRemoval.length - 1];
        const lastItemTitle = items.find(({ id }) => id === lastItemId);
        this.setState({
          headerTitle: `${lastItemTitle.name} +${
            selectionAfterRemoval.length - 1
          }`,
        });
      }
      this.setState({ selection: [...selectionAfterRemoval] });
      changeSelected([...selectionAfterRemoval]);
    }
  }

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  isItemInSelection(item) {
    const { selection } = this.state;
    return selection.some((current) => current === item.id);
  }

  handleClickOutside() {
    this.setState({ listOpen: false });
  }

  render() {
    const { title, items, withCheckbox } = this.props;
    const { listOpen, headerTitle, selection } = this.state;

    return (
      <div className="dd-wrapper">
        {selection.length !== 0 && (
          <div
            className="dd-clear"
            role="presentation"
            onClick={this.clearSelection}
          >
            <span className="icon-clear">
              <FontAwesomeIcon icon="times" />
            </span>
          </div>
        )}
        <div
          tabIndex={0}
          className="dd-header"
          role="button"
          onKeyPress={() => this.toggleList()}
          onClick={() => this.toggleList()}
        >
          <div
            className={classcat([
              "dd-header__title",
              { active: selection.length !== 0 },
            ])}
          >
            <p className="dd-header__title">
              {headerTitle.length < 20
                ? headerTitle
                : `${headerTitle.slice(0, 17)}...`}
            </p>
          </div>
          <div className="dd-header__action">
            {listOpen ? (
              <FontAwesomeIcon icon="chevron-up" />
            ) : (
              <FontAwesomeIcon icon="chevron-down" />
            )}
          </div>
        </div>

        {listOpen && (
          <ul className="dd-list">
            <li className="dd-list-header">
              <button type="button" onClick={() => this.toggleList()}>
                <span className="title">{title}</span>
                <FontAwesomeIcon icon="times" />
              </button>
            </li>
            {items.map((item) => (
              <li className="dd-list-item" key={item.id}>
                <button type="button" onClick={() => this.handleSelect(item)}>
                  {withCheckbox && (
                    <span className="checkbox">
                      {this.isItemInSelection(item) && (
                        <FontAwesomeIcon icon="check" />
                      )}
                    </span>
                  )}
                  <span>{item.name}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

Dropdown.defaultProps = {
  withCheckbox: true,
  multiSelect: false,
};

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  withCheckbox: PropTypes.bool,
  multiSelect: PropTypes.bool,
  items: PropTypes.array.isRequired,
  changeSelected: PropTypes.func.isRequired,
};

export default onClickOutside(Dropdown, Dropdown.handleClickOutside);
